import { defineMessages } from 'react-intl';

const messages = defineMessages({
  checkboxLabel: {
    id: 'frontbucket.repository.pullRequest.reviewedCheckbox.label',
    description: 'Label for file reviewed checkbox',
    defaultMessage: 'Viewed',
  },
});

export default messages;
